import { Capacitor, registerPlugin } from "@capacitor/core";

export type TextExportFile = {
  contents: string;
  mimeType: string;
  fileName: string;
};

export type TextExportResult = {
  fileName: string;
  uri: string | null;
  location: string;
  native: boolean;
};

type TheraExportPlugin = {
  saveTextFile(options: TextExportFile): Promise<{
    fileName: string;
    uri?: string;
    location?: string;
  }>;
};

const TheraExport = registerPlugin<TheraExportPlugin>("TheraExport");

function browserDownload(file: TextExportFile): TextExportResult {
  const blob = new Blob([file.contents], { type: file.mimeType });
  const href = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = href;
  anchor.download = file.fileName;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.setTimeout(() => URL.revokeObjectURL(href), 1000);
  return {
    fileName: file.fileName,
    uri: null,
    location: "Descargas del navegador",
    native: false,
  };
}

export async function exportTextFile(file: TextExportFile): Promise<TextExportResult> {
  if (Capacitor.getPlatform() === "android") {
    const result = await TheraExport.saveTextFile(file);
    return {
      fileName: result.fileName || file.fileName,
      uri: result.uri ?? null,
      location: result.location ?? "Descargas/THERA",
      native: true,
    };
  }
  return browserDownload(file);
}
